<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">

    <div class="d-flex justify-content-between mt-3 mb-1">
      <h2 class="me-2 text-truncate">
        <fa-icon [icon]=faUsers></fa-icon> mijn team
      </h2>
      @let tmplAssembleFormation = assembleFormation();
      @if(!processing() && pool) {
        <div>
          @if(pool.getAssemblePeriod().isIn()) {
            <button class="btn btn-secondary mx-2"
            [routerLink]="['/pool/scouting/list', pool.getId()]">
            <fa-icon [icon]=faUserSecret></fa-icon> <span class="ms-1 d-none d-sm-inline">
              scoutingslijst</span>
          </button>
          }          
          <button class="btn btn-secondary" [routerLink]="['/pool/formation/choose', pool.getId()]">
            @if(tmplAssembleFormation){
            <span>{{tmplAssembleFormation.getName()}}</span>
            }
          </button>
        </div>
      }
    </div>

    @if(processing()) {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
    
    @if(alert){
      <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
    }
    
    @if(!processing() && pool && tmplAssembleFormation && !selectedPlace){
      <div>
        <table class="table">
          <!-- lines-->
          @for(line of tmplAssembleFormation.getLines();track line.getNumber()) {
            <tbody app-pool-formationline-assemble [line]="line"
              (editPlace)="editPlace(pool,$event)" (linkToPlayer)="linkToPlayer(pool,$event)"
              [totalMarketValue]="line.getNumber() === GoalKeeper ? tmplAssembleFormation.calculateTotalMarketValue() : undefined">
            </tbody>
          }
        </table>
      </div>
    }
  </div>
</div>

@if(!processing() && pool){
<app-pool-navbar [current]="MyTeam" [pool]="pool" [poolUser]="poolUserFromSession"></app-pool-navbar>
}